// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._19pkidpf{margin-top:0}\n._1e0c1o8l{display:inline-block}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._otyridpf{margin-bottom:0}\n._p12f1osq{max-width:100%}\n._s7n4t94y{vertical-align:1px}", ""]);
// Exports
module.exports = exports;
